import { GetterTree } from "vuex";
import { AuthenticationState, CurrentUser, JwtConfigs, UserAutoSettings } from "./types";
import { RootState } from "@/store/types";
import { PermitionEnum } from "@/components/security/Permitions";

export const getters: GetterTree<AuthenticationState, RootState> = {
    isLoggedIn(state): boolean {
        return Boolean(state.token);
    },
    getCurrentUser(state): CurrentUser {
        return state.currentUser;
    },
    getToken(state): string {
        return state.token;
    },
    authorize(state) {
        return (param: PermitionEnum) => {
            if (!param) {
                return false;
            }
            const isAuthorized: boolean = state.currentUser.permissions.some(function (permission: string) {
                return PermitionEnum[permission as keyof typeof PermitionEnum] === param;
            });
            return isAuthorized;
        };
    },
    getJwtConfigs(state): JwtConfigs {
        return state.jwtConfigs;
    },
    getAutologout(state): boolean {
        return state.autoLogout;
    },
    getUserAutoSettings(state): UserAutoSettings {
        return state.currentUser.userAutoSettings;
    },

    getUserHasFolderAccess(state): boolean {
        if (state.currentUser.permissions.includes("AdminPrivilege")) return true;
        return state.currentUser.userResourceClaims.some(x => x.resourceType === "Folder");
    }
};
